import { NgModule } from 'ng-metadata/core';
import { PassportDepartureDateComponent } from './departure-date.component';

@NgModule({
  declarations: [
    PassportDepartureDateComponent,
  ],
})
export class PassportDepartureDateModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/departure-date/departure-date.module.ts